module.exports = __webpack_public_path__ + "static/media/threat_analy2.9087cf47.png";